import { useParams } from 'src/routes/hooks';
import ProductDetailView from 'src/sections/management/product/view/product-detail-view';

export default function ProductDetail() {
  const { id } = useParams();

  return <ProductDetailView id={id!} />;
}
